<template>
  <div
    class="m-event pc new"
    @click="hideBox"
    :style="{
      'padding-top':
        extras &&
        extras.groupNavbarDisplay &&
        extras.groupNavbarDisplay.display == 0
          ? 0
          : '',
    }"
  >
    <Header
      @routerEvent="layoutEvent"
      @logout="logout"
      v-if="extras && seminarInfo"
      :loginUrl="loginUrl"
      :registerUrl="registerUrl"
      :extras="extras"
      :seminarInfo="seminarInfo"
      :memberInfo="memberInfo"
    />
    <Suspension
      ref="suspension"
      v-if="extras && memberInfo && seminarInfo"
      :extras="extras"
      :isFrozen="isFrozen"
      :signUpStatus="signUpStatus"
      :seminarInfo="seminarInfo"
      :markCode="markCode"
      :memberInfo="memberInfo"
    />
    <div v-for="(item, index) in orderList" :key="index">
      <Banner
        v-if="extras && seminarInfo && item.name == 'kvOrder'"
        :seminarInfo="seminarInfo"
        :memberInfo="memberInfo"
        :isFrozen="isFrozen"
        :signUpStatus="signUpStatus"
        :loginUrl="loginUrl"
        :registerUrl="registerUrl"
        :extras="extras"
      />

      <Introduction
        v-if="extras && seminarInfo && item.name == 'introductionOrder'"
        :seminarInfo="seminarInfo"
        :extras="extras"
      />
      <GuestInfo
        v-if="extras && seminarInfo && item.name == 'guestOrder'"
        :guests="seminarInfo.guests"
        :guestsI18n="seminarInfo.i18n && seminarInfo.i18n.guests"
        :extras="extras"
      />
      <Schedule
        v-if="extras && seminarInfo && item.name == 'scheduleOrder'"
        :extras="extras"
        :agendas="seminarInfo.agendas"
        :agendaI18n="seminarInfo.agendaI18n"
        :guestsI18n="seminarInfo.i18n && seminarInfo.i18n.guests"
        :subSeminarI18n="seminarInfo.subSeminarI18n"
      />
      <NewInfo
        v-if="extras && newsInfo && item.name == 'newsOrder'"
        :newsInfo="newsInfo"
        :extras="extras"
      />
      <DownloadInfo
        v-if="extras && fileInfo && item.name == 'downloadOrder'"
        :seminarInfo="seminarInfo"
        :memberInfo="memberInfo"
        :fileInfo="fileInfo"
        :extras="extras"
      />
      <Partner
        v-if="extras && partnerInfo && item.name == 'partnerOrder'"
        :partnerInfo="partnerInfo"
        :extras="extras"
      />
      <Custom
        v-if="extras && item.name == 'custom1Order'"
        :extras="extras"
        :index="1"
        :type="''"
      ></Custom>
      <Custom
        v-if="extras && item.name == 'custom2Order'"
        :extras="extras"
        :index="2"
        :type="''"
      ></Custom>
      <Custom
        v-if="extras && item.name == 'custom3Order'"
        :extras="extras"
        :index="3"
        :type="''"
      ></Custom>
    </div>

    <Footer v-if="extras" :extras="extras"></Footer>
  </div>
</template>

<script>
import Header from "@/components/pc/HeaderNew.vue";
import Banner from "@/components/pc/BannerNew.vue";
import Introduction from "@/components/pc/IntroductionNew.vue";
import Schedule from "@/components/pc/ScheduleNew.vue";
import GuestInfo from "@/components/pc/GuestInfoNew.vue";
import NewInfo from "@/components/pc/NewInfoNew.vue";
import Partner from "@/components/pc/PartnerNew.vue";
import DownloadInfo from "@/components/pc/DownloadInfoNew.vue";
import Suspension from "@/components/pc/SuspensionNew.vue";
import Footer from "../../components/pc/FooterNew";
import Custom from "../../components/pc/CostomImg";
import Api from "../../service/api";
import { URLS } from "fire-wind-water";
import seminarMixin from "../../mixins/seminar";

export default {
  name: "Index",
  data() {
    return {
      fileInfo: null,
      newsInfo: null,
      partnerInfo: null,
      isMobile: !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i),
    };
  },
  components: {
    Header,
    Banner,
    Introduction,
    Schedule,
    GuestInfo,
    NewInfo,
    DownloadInfo,
    Partner,
    Suspension,
    Footer,
    Custom,
  },
  mixins: [seminarMixin],
  created() {
    window.$sk.loading.show();
    this.initPage();
  },
  computed: {
    loginUrl: function () {
      if (URLS.getURL("isSetting") == 1) {
        return "";
      }
      if (this.handleBackUrl && this.seminarInfo) {
        return this.handleBackUrl(this.seminarInfo.login);
      } else {
        return "";
      }
    },
    registerUrl: function () {
      if (URLS.getURL("isSetting") == 1) {
        return "";
      }
      if (this.handleBackUrl && this.seminarInfo) {
        return this.handleBackUrl(this.seminarInfo.register);
      } else {
        return "";
      }
    },
  },
  methods: {
    async initPage() {
      const instanceId = URLS.getURL("instanceId");
      let info = window.$sk.template.get();
      const { globalUserId } = info.user;
      await Api.getArticleList({
        instanceId,
        globalUserId,
        sort: [6, 8],
        isColumnSort: true,
        type: "news", //新闻资讯
      }).subscribe((newsInfoRes) => {
        this.newsInfo = newsInfoRes.content;
      });

      await Api.getArticleList({
        instanceId,
        globalUserId,
        isColumnSort: true,
        sort: [6, 8],
        type: "partner", //合作伙伴
      }).subscribe((partnerInfoRes) => {
        this.partnerInfo = partnerInfoRes.content;
      });

      await Api.getFileList({
        instanceId,
        globalUserId,
      }).subscribe((FileRes) => {
        this.fileInfo = FileRes.content;
      });
      // window.$sk.loading.hide();
    },
    logout() {
      const info = window.$sk.template.get();
      info.cookie.removeSession();
      this.$refs.suspension.clearSession();
      this.memberInfo = {
        name: "",
        headImg: "",
        email: "",
        signUpStatus: 0,
      };
    },
    handleBackUrl: function (url) {
      if (!url) {
        return "";
      } else {
        let _url = "";
        const hasBackUrl = url.indexOf("backUrl");
        if (hasBackUrl !== -1) {
          _url =
            url.slice(0, hasBackUrl - 1) +
            "&backUrl=" +
            encodeURIComponent(location.href);
        } else {
          _url = url + "&backUrl=" + encodeURIComponent(location.href);
        }
        return _url;
      }
    },
    downloadEvent(mailbox, fileList) {
      const instanceId = URLS.getURL("instanceId");
      const { globalUserId } = this.template.user;
      Api.getDownloadWithEmail({
        instanceId,
        email: mailbox,
        globalUserId,
        moduleType: 3,
        fileList: fileList,
      }).subscribe(() => {});
    },
    layoutEvent(item) {
      const stel = document.getElementById(item.key);
      if (stel) {
        stel.scrollIntoView({
          block: "start", //默认跳转到顶部
          behavior: "smooth", //滚动的速度
        });
      }
    },
    hideBox(e) {
      let isBox = false;
      if (e && e.path) {
        e.path.forEach((path) => {
          if (path.className) {
            let className = path.className.toString();
            if (className.indexOf("m-qrcode") >= 0) {
              isBox = true;
            }
          }
        });
        if (!isBox) {
          this.$refs.suspension.closeBox();
        }
      }
    },
  },
};
</script>
